module.exports = __webpack_public_path__ + "img/8 loly.8aa6b4fc.jpg";